import React from 'react';

import { BREAKPOINT } from '@latitude/core/utils/constants';

import PageHeaderSection from '@/components/PageLayout/PageHeader';

import heroImage from '../images/low-rate-ach-form-hero.webp';
import heroImageBackground from '../images/addcard-hero-bg.webp';

function AchPageHeaderSection({ children }) {
  return (
    <div
      className="pageHeader"
      css={`
        margin-top: 120px;
        && section.lfs-pageheader {
          background-color: #ccc;
          background-image: url(${heroImageBackground});
          background-size: cover;
        }
        && section.lfs-pageheader h1.lfs-pageheader-title {
          color: #1964b4;
        }
        && section.lfs-pageheader div.lfs-pageheader-image img {
          height: 100%;
          padding: 30pt 0;
        }
        @media (min-width: ${BREAKPOINT.LG}) {
          && div.lfs-pageheader-hero > div {
            max-height: 400px;
          }
          && div.HeroContent {
            padding: 0 0;
          }
        }
      `}
    >
      <PageHeaderSection
        title="Become the ultimate shopping team"
        subTitle={null}
        pageImage={heroImage}
        pageImageAlt="Low Rate Mastercard"
      >
        {children}
      </PageHeaderSection>
    </div>
  );
}

export default AchPageHeaderSection;
